import { Component, Input } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-combined-indicator-card',
  standalone: true,
  imports: [CommonModule, CurrencyPipe],
  template: `
    <div class="combined-card" [ngClass]="'combined-' + color">
      <div class="card-header">
        <div class="header-left">
          <h6 class="card-title">{{ title }}</h6>
          <span class="period-badge">{{ period }}</span>
        </div>
        <i class="bi icon" [ngClass]="icon"></i>
      </div>

      <div class="card-content">
        <div class="metric-row">
          <div class="metric volume-metric">
            <span class="metric-label">Volume</span>
            <span class="metric-value volume-value">{{ volume | number:'1.0-0' }}</span>
          </div>
          <div class="separator"></div>
          <div class="metric value-metric">
            <span class="metric-label">Total</span>
            <span class="metric-value currency-value">{{ valor | currency:'BRL':'symbol':'1.2-2' }}</span>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .combined-card {
      border-radius: 12px;
      padding: 16px;
      height: 100%;
      border: 1px solid #e8eef7;
      background: #ffffff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .combined-card:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    }

    .combined-card::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: var(--card-color);
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 14px;
      gap: 10px;
    }

    .header-left {
      flex: 1;
    }

    .card-title {
      font-size: 0.95rem;
      font-weight: 700;
      color: #2c3e50;
      margin: 0 0 6px 0;
      line-height: 1.2;
    }

    .period-badge {
      display: inline-block;
      font-size: 0.7rem;
      font-weight: 600;
      text-transform: uppercase;
      padding: 3px 8px;
      border-radius: 4px;
      background: var(--card-bg-soft);
      color: var(--card-color);
    }

    .icon {
      font-size: 1.4rem;
      color: var(--card-color);
      flex-shrink: 0;
      opacity: 0.9;
    }

    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .metric-row {
      display: grid;
      grid-template-columns: 1fr 2px 1fr;
      gap: 12px;
      align-items: center;
    }

    .metric {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .metric-label {
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: uppercase;
      color: #8192a3;
      letter-spacing: 0.3px;
    }

    .metric-value {
      font-size: 1.3rem;
      font-weight: 800;
      color: var(--card-color);
      word-break: break-word;
    }

    .volume-value {
      font-size: 1.5rem;
    }

    .currency-value {
      font-size: 1.1rem;
    }

    .separator {
      background: #e8eef7;
      height: 100%;
      width: 1px;
    }

    /* Color Variants */
    .combined-primary { --card-color: #0d6efd; --card-bg-soft: rgba(13, 110, 253, 0.12); }
    .combined-success { --card-color: #198754; --card-bg-soft: rgba(25, 135, 84, 0.12); }
    .combined-danger { --card-color: #dc3545; --card-bg-soft: rgba(220, 53, 69, 0.12); }
    .combined-info { --card-color: #0dcaf0; --card-bg-soft: rgba(13, 202, 240, 0.12); }

    @media (max-width: 576px) {
      .card-title {
        font-size: 0.9rem;
      }

      .metric-value {
        font-size: 1.1rem;
      }

      .volume-value {
        font-size: 1.2rem;
      }

      .currency-value {
        font-size: 0.95rem;
      }
    }
  `]
})
export class CombinedIndicatorCardComponent {
  @Input() title: string = '';
  @Input() period: string = '';
  @Input() volume: number = 0;
  @Input() valor: number = 0;
  @Input() color: 'primary' | 'success' | 'danger' | 'info' = 'primary';
  @Input() icon: string = 'bi-info-circle';
}
